import React, { useCallback, useMemo } from 'react'
import styled from '@emotion/styled'
import { NegotiationDetail, TradeConditionFlag } from 'api'
import { AxeTradeConditionButtons } from 'view/shared/entity'
import { GridAxeTradeConditionButtonsProps } from 'view/components/datagrid/renderers/AxeTradeConditionRenderer'
import { NegotiationFieldNames } from './LiveGridColumnNames'
import { canUpdateAttributes, getNegotiationModificationColor } from '../shared/utils'
import { getAxeTradeConditionModificationType } from '../shared/deltaGetters'

interface LiveAxeTradeConditionButtonsProps extends GridAxeTradeConditionButtonsProps<NegotiationDetail> {}

const NegotiableCellWrapper = styled.div<{ modificationColor: string | null }>`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  border-top: ${props => (props.modificationColor ? '4px solid transparent' : 'none')};
  border-bottom: ${props => (props.modificationColor ? `4px solid ${props.modificationColor}` : 'none')};
`

export const LiveAxeTradeConditionButtons: React.FunctionComponent<LiveAxeTradeConditionButtonsProps> = props => {
  const { data, rowInEdit, onUpdate } = props

  const handleUpdate = useCallback(
    (isAxed: boolean, tradeConditionFlag: TradeConditionFlag, negotiationDetail: NegotiationDetail) => {
      if (negotiationDetail.axeTradeCondition.isAxed !== isAxed) {
        onUpdate(negotiationDetail.negotiation.negotiationId, negotiationDetail, NegotiationFieldNames.AXE, isAxed)
      }
      if (negotiationDetail.axeTradeCondition.tradeCondition !== tradeConditionFlag) {
        onUpdate(negotiationDetail.negotiation.negotiationId, negotiationDetail, NegotiationFieldNames.ROLL_UNWIND, tradeConditionFlag)
      }
    },
    [onUpdate]
  )

  const modificationColor = useMemo(() => getNegotiationModificationColor(getAxeTradeConditionModificationType, data), [data])

  return (
    <NegotiableCellWrapper modificationColor={rowInEdit ? null : modificationColor}>
      <AxeTradeConditionButtons
        isAxed={data.axeTradeCondition.isAxed}
        axeReadOnly={true}
        tradeConditionFlag={data.axeTradeCondition.tradeCondition}
        readOnly={!canUpdateAttributes(data)}
        onUpdate={(isAxed, tradeConditionFlag) => handleUpdate(isAxed, tradeConditionFlag, data)}
        dataTestId={'LiveAxeTradeConditionButtons'}
      />
    </NegotiableCellWrapper>
  )
}
